import React, { useState, useEffect } from "react";
import {
  Wrapper,
  ImageContainer,
  StyledImage,
  HoverText,
} from "./Stories.styled";

const Stories = () => {
  const images = [
    { src: "./img1.jpg", alt: "Image 1", hoverText: "Happy" },
    { src: "./img2.jpg", alt: "Image 2", hoverText: "Birthday" },
    { src: "./img3.jpg", alt: "Image 3", hoverText: "Boss" },
    { src: "./img4.jpg", alt: "Image 4", hoverText: "Realyn" },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Wrapper>
      {images.map((image, index) => (
        <ImageContainer key={index} isActive={index === activeIndex}>
          <StyledImage src={image.src} alt={image.alt} />
          <HoverText>{image.hoverText}</HoverText>
        </ImageContainer>
      ))}
    </Wrapper>
  );
};

export default Stories;
